import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { FSA } from '../flux-standard-action';
import { SelectionItemInterface } from './selections';

const initialState = {
  items: [],
  actionIntent: undefined,
  fromFolder: null
};

const ns = 'cube3/clipboard';

// Actions
const COPY_ITEMS = `${ns}/COPY_ITEMS`;
const MOVE_ITEMS = `${ns}/MOVE_ITEMS`;
const PASTE_ITEMS = `${ns}/PASTE_ITEMS`;
const CLEAR_ITEMS = `${ns}/CLEAR_ITEMS`;
const REQUEST_CLIPBOARD_SYNC = `${ns}/REQUEST_CLIPBOARD_SYNC`;
//
const COPY_INTENT = `${ns}/intents/COPY_INTENT`;
const MOVE_INTENT = `${ns}/intents/MOVE_INTENT`;

export interface ClipboardState {
  actionIntent: keyof typeof actionIntents;
  items: SelectionItemInterface[];
}

export const actions = {
  COPY_ITEMS,
  MOVE_ITEMS,
  PASTE_ITEMS,
  CLEAR_ITEMS,
  REQUEST_CLIPBOARD_SYNC
};

export const actionIntents = {
  COPY_INTENT,
  MOVE_INTENT
};

const copyItems = (items: ResourceIdentifier<'asset' | 'folder'>[]) => ({
  type: actions.COPY_ITEMS,
  payload: { items: items.map(i => ({ id: i.id, type: i.type })) }
});

const moveItems = (items: ResourceIdentifier<'asset' | 'folder'>[], fromFolder: ResourceIdentifier<'folder'>) => ({
  type: actions.MOVE_ITEMS,
  payload: { items: items.map(i => ({ id: i.id, type: i.type })), fromFolder }
});

const pasteItems = (targetFolder: ResourceIdentifier<'folder'>) => ({
  type: actions.PASTE_ITEMS,
  payload: { type: targetFolder.type, id: targetFolder.id },
  meta: {
    apiClient: {
      targetFolder
    }
  }
});

const clearItems = () => ({
  type: actions.CLEAR_ITEMS,
  payload: null
});

export const actionCreators = {
  copyItems,
  moveItems,
  pasteItems,
  clearItems
};

const getClipboardItems = state => state.items;
const getClipboardIntent = state => state.actionIntent;
const getClipboardFromFolder = state => state.fromFolder;
const isOnClipboard = (items, item) =>
  !!items.filter(i => i.id === item.id && i.type === item.type).length;

export const selectors = {
  getClipboardItems,
  getClipboardIntent,
  getClipboardFromFolder,
  isOnClipboard
};

export const clipboardReducer = (state = initialState, action: FSA) => {
  const { type, payload } = action;

  switch (type) {
    case actions.COPY_ITEMS:
      return {
        items: [...payload.items],
        actionIntent: actionIntents.COPY_INTENT,
        fromFolder: null


      };

    case actions.MOVE_ITEMS:
      return {
        items: [...payload.items],
        actionIntent: actionIntents.MOVE_INTENT,
        fromFolder: payload.fromFolder
      };

    case actions.PASTE_ITEMS:
      return {
        items: state.items,
        actionIntent: actionIntents.COPY_INTENT,
        fromFolder: null

      };

    case actions.CLEAR_ITEMS:
      return {
        items: [],
        actionIntent: undefined,
        fromFolder: null

      };

    default:
      return state;
  }
};

export default clipboardReducer;
